// extracted by mini-css-extract-plugin
export default {"body":"Galaxy_body__P8Qxp","information__module_mobile":"Galaxy_information__module_mobile__enAWc","goto__zone":"Galaxy_goto__zone__HX1rS"};